import Menu from '@mui/material/Menu';
import * as React from 'react';
import ProfileMenu from '../ProfileMenu';

interface ProfileModalProps {
    open: boolean;
    onClose: any;
    anchorEl: null | HTMLElement;
    handleClick: any;
    handleClose: any;
    handleTheme: any;
}

const ProfileMenuModal: React.FC<ProfileModalProps> = ({ open, onClose, anchorEl, handleClick, handleClose, handleTheme }) => {
    //   const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    //   const open = Boolean(anchorEl);
    //   const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    //     setAnchorEl(event.currentTarget);
    //   };
    //   const handleClose = () => {
    //     setAnchorEl(null);
    //   };

    return (
        <Menu
            id="demo-positioned-menu"
            // aria-labelledby="demo-positioned-button"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left'
            }}
            transformOrigin={{
                vertical: 'bottom',
                horizontal: 'left'
            }}
            sx={{ mt: 5.5 }}
            MenuListProps={{
                'aria-labelledby': 'demo-positioned-button',
                sx: {
                    px: 1,
                    bgcolor: 'background.default'
                }
            }}
        >
            {/* <ProfilePopupMenu handleClose={handleClose} handleTheme={handleTheme} hasDivider={true} /> */}
            <ProfileMenu handleClose={handleClose} hasDivider={true} />
        </Menu>
    );
};

export default ProfileMenuModal;
